type BalanceSufficiencyParams = {
  totalAmountInCents: number;
  period: string;
  periodLimit: number;
  spent: number;
  allowPurchaseWithNegativeBalance?: boolean;
};

export const isBalanceSufficient = ({
  totalAmountInCents,
  period,
  periodLimit,
  spent,
  allowPurchaseWithNegativeBalance,
}: BalanceSufficiencyParams): boolean => {
  // Negative balance applies only when the wallet balance itself is the cap.
  // Spending limits must continue to be enforced by the totem.
  if (allowPurchaseWithNegativeBalance && period === "") {
    return true;
  }

  return totalAmountInCents / 100 <= periodLimit - spent;
};
